import {
  alpha,
  Components,
  Theme,
  toggleButtonGroupClasses,
} from '../../material';
import { borderRadius } from '../tokens';

export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      flexGrow: 1,
      padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
      color: theme.palette.secondary.main,
      [`&.${toggleButtonGroupClasses.firstButton} , &.${toggleButtonGroupClasses.middleButton}, &.${toggleButtonGroupClasses.lastButton}`]:
        {
          border: 'none',
          borderRadius: borderRadius.abs(theme.shape.borderRadius, 's'),
        },
      [`&.${toggleButtonGroupClasses.selected}`]: {
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.action.selected,
      },
    }),
  },
};

export const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(0.5),
      border: `1px solid ${alpha(theme.palette.secondary.main, 0.5)}`,
      gap: theme.spacing(0.5),
    }),
  },
};
